<template>
  <div class="dpi px">
    <div class="list">
      <div class="param-item">
        <div class="name">{{ $t("mouse.dpiLevel") }}</div>
        <a-radio-group
          :value="currentID"
          class="radio-group"
          @change="onCurrentIDChange"
        >
          <transition-group name="dpi-fade" tag="div" class="dpi-buttons-container">
            <a-radio-button
              class="radio"
              v-for="(color, index) in DPIcolor.slice(0, actualDPIMax)"
              :value="index"
              :key="`dpi-${index}`"
            >
            <div class="color" :style="{ backgroundColor: color }"></div>
            {{ index + 1 }}
            <md-field class="number">
              <span class="md-prefix" v-if="isOpen === 0">X</span>
              <md-input
                class="number-input"
                v-model="xDPI[index]"
                @blur="onSliderChange(index, $event.target.value, 'x')"
                @keypress.enter="
                  onSliderChange(index, $event.target.value, 'x')
                "
                :max="maxDPI"
                :min="50"
                :step="50"
              ></md-input>
            </md-field>
            <md-field class="number" v-if="isOpen === 0">
              <span class="md-prefix" v-if="isOpen === 0">Y</span>
              <md-input
                class="number-input"
                v-model="yDPI[index]"
                @blur="onSliderChange(index, $event.target.value, 'y')"
                @keypress.enter="
                  onSliderChange(index, $event.target.value, 'y')
                "
                :max="maxDPI"
                :min="50"
                :step="50"
              ></md-input>
            </md-field>
          </a-radio-button>
          </transition-group>
        </a-radio-group>
      </div>
      <template v-for="(dpi, index) in xDPI.slice(0, actualDPIMax)">
        <div class="param-item item" :key="index" v-if="index === currentID">
          <div class="name"></div>
          <div class="xy">
            <div class="x">
              <a-slider
                class="slider"
                :value="xDPI[index] || undefined"
                @change="onSliderChange(index, $event, 'x')"
                :max="maxDPI"
                :min="0"
                :tooltipVisible="false"
                :step="50"
              />
            </div>
            <div class="y" v-if="isOpen === 0">
              <a-slider
                class="slider"
                :value="yDPI[index] || undefined"
                @change="onSliderChange(index, $event, 'y')"
                :max="maxDPI"
                :min="0"
                :step="50"
                :tooltipVisible="false"
              />
            </div>
          </div>
          <a-tooltip placement="right">
            <template slot="title">
              <sketch-picker
                class="picker"
                :value="DPIcolor[index]"
                disableAlpha
                @input="onColorInput(index, $event)"
                :preset-colors="[
                  '#D0021B',
                  '#F5A623',
                  '#F8E71C',
                  '#8B572A',
                  '#7ED321',
                  '#417505',
                  '#BD10E0',
                  '#9013FE',
                  '#4A90E2',
                  '#50E3C2',
                  '#B8E986',
                  '#000000',
                  '#444444',
                  '#888888',
                  '#CCCCCC',
                  '#FFFFFF',
                ]"
              />
            </template>
            <div
              class="color"
              :style="{ backgroundColor: DPIcolor[index] }"
            ></div>
          </a-tooltip>
        </div>
      </template>
      <div class="param-item">
        <div class="name">{{ $t("mouse.dpiXY") }}</div>
        <a-radio-group
          :value="isOpen"
          class="radio-group"
          @change="onOpenChange"
        >
          <a-radio class="radio" :value="1">
            {{ $t("mouse.dpiSync") }}
          </a-radio>
          <a-radio class="radio" :value="0">
            {{ $t("mouse.dpiAsync") }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="param-item" v-if="shouldShowDPICount">
        <div class="name">{{ $t("mouse.dpiCount") }}</div>
        <div class="dpi-max-control">
          <a-slider
            class="dpi-max-slider"
            :value="DPImax"
            @change="onDPIMaxChange"
            @afterChange="onDPIMaxAfterChange"
            :min="1"
            :max="8"
            :step="1"
            :tooltipVisible="false"
          />
          <div class="dpi-max-value">{{ DPImax }}</div>
        </div>
      </div>
      <div class="param-item">
        <div class="name">{{ $t("mouse.dpiButtonSwitch") }}
            <a-popover placement="right">
          <template slot="content">
            <div class="name-question">
              {{ $t("mouse.dpiButtonTip") }}
            </div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
        </div>
        <a-radio-group
          :value="Number(setDPIButton)"
          class="radio-group"
          @change="onDPIButtonChange"
        >
          <a-radio class="radio" :value="1">
            {{ $t("mouse.on") }}
          </a-radio>
          <a-radio class="radio" :value="0">
            {{ $t("mouse.off") }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="param-item" v-if="false">
        <div class="name">{{ $t("mouse.currentDPI") }}</div>
        <a-radio-group
          :value="currentID"
          class="radio-group"
          @change="onCurrentIDChange"
        >
          <a-radio
            class="radio"
            v-for="(color, index) in DPIcolor.slice(0, actualDPIMax)"
            :value="index"
            :key="index"
          >
            {{ index + 1 }}
          </a-radio>
        </a-radio-group>
      </div>
    </div>
    <div class="button" @click="onSave" v-if="false">
      {{ $t("save") }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CMouseDpi",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      currentIndex: 0,
      profile: 0, // （按键层：0~4）
      timer: 0,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
    ...mapState("mouse", {
      DPI: "DPI",
      param: "param",
      currentID: (state) => state.DPI.currentID,
      isOpen: (state) => state.DPI.isOpen,
      xDPI: (state) => state.DPI.xDPI,
      yDPI: (state) => state.DPI.yDPI,
      DPIcolor: (state) => state.DPI.DPIcolor,
      DPImax: (state) => state.DPI.DPImax,
      setDPIButton: (state) => state.DPI.setDPIButton,
    }),
    maxDPI() {
      return this.param.mouseID === 1935 ? 26000 : 30000;
    },
    // 计算实际的DPIMax值，如果未定义则默认为8
    actualDPIMax() {
      return this.DPImax !== undefined ? this.DPImax : 8;
    },
    // 决定是否显示DPI数量控制
    shouldShowDPICount() {
      return this.DPImax !== undefined;
    },
  },
  mounted() {
    // 防抖：快速切换 tab 时，只让最后一次切换的 tab 发送请求
    if (this.$parent._dpiQueryTimer) {
      clearTimeout(this.$parent._dpiQueryTimer);
    }
    
    this.$parent._dpiQueryTimer = setTimeout(() => {
      this.$parent._dpiQueryTimer = null;
      this.$parent.lastDPIButtonQueryTime = Date.now();
      this.$store.dispatch("loader/getMouseDPIButton", {});
    }, 300);
  },
  beforeDestroy() {
    // 组件销毁时清理查询定时器，避免切换 tab 后还发送请求
    if (this.$parent._dpiQueryTimer) {
      clearTimeout(this.$parent._dpiQueryTimer);
      this.$parent._dpiQueryTimer = null;
    }
    
    // 组件销毁前清理定时器，避免内存泄漏
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
      // 离开页面时如果有未保存的操作，立即保存一次
      this.onSave && this.onSave();
    }
  },
  methods: {
    onDPIButtonChange(e) {
      const setDPIButton = Number(e.target.value);
      this.$store.dispatch("mouse/setDPI", {
        ...this.DPI,
        setDPIButton: setDPIButton
      });
      // 专门调用 setDPIButton 方法
      this.$store.dispatch("loader/setMouseDPIButton", { setDPIButton });
      // 注意: 不在这里显示提示,统一由 updateDPIButton 回调处理
      // 这样网页操作和鼠标按钮操作都会显示提示,体验一致
    },
    onOpenChange(e) {
      const isOpen = e.target.value;
      const yDPI = isOpen === 1 ? [...this.xDPI] : [...this.yDPI];
      this.$store.dispatch("mouse/setDPI", { ...this.DPI, isOpen, yDPI });
    },
    onCurrentIDChange(e) {
      const index = e.target.value;
      // 确保选择的档位在actualDPIMax范围内
      if (index < this.actualDPIMax && this.xDPI[index] > 0 && this.currentID != index) {
        this.$store.dispatch("mouse/setDPI", { ...this.DPI, currentID: index });
        this.onSave();
      }
    },
    onSliderChange(index, value, xy) {
      // 修改 DPI 数值，但不改变 currentID（不切换档位）
      const xDPI = [...this.xDPI];
      xDPI[index] = Math.min(
        Math.max(Math.floor(Number(value) / 50) * 50, 50),
        this.maxDPI
      );
      const yDPI = [...this.yDPI];
      yDPI[index] = xDPI[index];

      if (xy == "x") {
        if (this.isOpen == 1) {
          this.$store.dispatch("mouse/setDPI", {
            ...this.DPI,
            xDPI,
            yDPI: xDPI,
          });
        } else {
          this.$store.dispatch("mouse/setDPI", { ...this.DPI, xDPI });
        }
      } else if (xy == "y") {
        this.$store.dispatch("mouse/setDPI", { ...this.DPI, yDPI });
      }

      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.onSave, 200);
    },
    onColorInput(index, e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      const DPIcolor = [...this.DPIcolor];
      DPIcolor[index] = color.length === 7 ? color : "#000000";
      this.$store.dispatch("mouse/setDPI", { ...this.DPI, DPIcolor });
      this.onSave();
    },
    onDPIMaxChange(value) {
      // 确保当前选中的DPI档位不超过新的最大值
      let newCurrentID = this.currentID;
      if (this.currentID >= value) {
        newCurrentID = value - 1;
      }
      
      this.$store.dispatch("mouse/setDPI", { 
        ...this.DPI, 
        DPImax: value,
        currentID: newCurrentID
      });
    },
    onDPIMaxAfterChange(value) {
      this.onSave();
    },
    onSave() {
      if (this.currentID >= 0) {
        const saveData = {
          profile: this.profile,
          currentID: this.currentID,
          isOpen: this.isOpen,
          xDPI: this.xDPI,
          yDPI: this.yDPI,
          DPIcolor: this.DPIcolor,
        };
        
        // 只有当DPIMax已定义时才包含它
        if (this.shouldShowDPICount) {
          saveData.DPImax = this.DPImax;
        }
        
        this.$store.dispatch("loader/setMouseDPI", saveData);
        // this.$message.info(this.$t("loader.saveSuccess"));
      } else {
        this.$message.info(this.$t("mouse.dpiError"));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dpi {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .list {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .param-item {
      @include flex-center;
      width: 1200px;
      justify-content: flex-start;
      padding: 15px 0;
      font-size: 20px;

      .name {
        font-size: 20px;
        width: 180px;
        margin-right: 20px;
        .name-tip {
        color: $primary-color;
        margin-left: 5px;
        cursor: pointer;
      }
      }

      .dpi-buttons-container {
        @include flex-center;
        gap: 0;
      }

      .radio-group {
        @include flex-center;

        .radio {
          @include flex-center;
          height: auto;
          text-align: center;

          .color {
            width: 15px;
            height: 15px;
            border-radius: 2px;
            border: 1px solid #717171;
            margin: 10px auto 5px auto;
          }

          .number {
            width: 80px;
            color: #717171;
            background: #222222;
            letter-spacing: 0;
            padding: 0 5px;
            height: 32px;
            min-height: 32px;
            line-height: 32px;
            border: 0;
            margin: 0px auto 10px auto;

            .number-input {
              width: 50px;
              height: 32px;
              min-height: 32px;
              line-height: 32px;
              text-align: center;
              font-size: 14px;
            }
          }
        }
      }

      .dpi-max-control {
        @include flex-center;
        
        .dpi-range-label {
          font-size: 16px;
          color: #ffffff;
          
          &:first-of-type {
            margin-right: 15px;
          }
          
          &:last-of-type {
            margin-left: 15px;
          }
        }
        
        .dpi-max-slider {
          width: 300px;
        }
        
        .dpi-max-value {
          font-size: 20px;
          color: #ffffff;
          min-width: 20px;
          text-align: center;
          margin-left: 20px;
        }
      }
    }

    .item {
      .radio {
        width: 30px;
        height: 30px;
        border: 2px solid #3c3c3c;
        border-radius: 50%;
        padding: 3px;
        margin-right: 30px;
        cursor: pointer;
      }

      .xy {
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .x,
      .y {
        @include flex-center;
      }

      .y {
        margin-top: 10px;
      }

      .slider {
        width: 300px;
        margin-right: 30px;
      }

      .number {
        width: 90px;
        font-size: 20px;
        color: #717171;
        letter-spacing: 0;
        margin: 0 30px 0 0;
        padding: 0;
        height: 40px;
        min-height: 40px;
        line-height: 40px;

        .number-input {
          width: 100%;
          text-align: center;
        }
      }

      .color {
        width: 30px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid #717171;
      }

      .picker {
        color: #000000;
      }

      &.active {
        background: #222222;

        .radio::before {
          width: 100%;
          height: 100%;
          display: block;
          content: "";
          background-color: $primary-color;
          border-radius: 50%;
        }

        .number {
          color: #ffffff;
        }

        .color {
          border: 1px solid #ffffff;
        }
      }
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss">
.dpi {
  .info {
    .item {
      .slider {
        padding: 4px 0;
        .ant-slider-rail {
          height: 6px;
          background-color: #717171 !important;
        }

        .ant-slider-track {
          height: 6px;
          background-color: #3c3c3c !important;
        }

        .ant-slider-step {
          height: 6px;
        }

        .ant-slider-handle {
          width: 30px;
          height: 30px;
          margin-top: -12px;
          background-color: #3c3c3c !important;
          border: 0;
          box-shadow: none;
        }
      }

      &.active .slider {
        .ant-slider-track {
          background-color: $primary-color !important;
        }

        .ant-slider-handle {
          background-color: $primary-color !important;
        }
      }
    }
  }
  
  .dpi-max-control {
    .dpi-max-slider {
      padding: 4px 0;
      
      .ant-slider-rail {
        height: 4px;
        background-color: #717171 !important;
      }

      .ant-slider-track {
        height: 4px;
        background-color: $primary-color !important;
      }

      .ant-slider-step {
        height: 4px;
      }

      .ant-slider-handle {
        width: 20px;
        height: 20px;
        margin-top: -7px;
        background-color: $primary-color !important;
        border: 0;
        box-shadow: none;
      }
    }
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}

// DPI level transition animations
.dpi-fade-enter-active, .dpi-fade-leave-active {
  transition: all 0.3s ease;
}

.dpi-fade-enter {
  opacity: 0;
  transform: translateX(-20px);
}

.dpi-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.dpi-fade-move {
  transition: transform 0.3s ease;
}

// 简单粗暴的解决方案 - 直接覆盖ant design的圆角样式
.dpi-buttons-container .ant-radio-button-wrapper {
  transition: all 0.3s ease !important;
  
  &:first-child {
    border-top-left-radius: 6px !important;
    border-bottom-left-radius: 6px !important;
  }
  
  &:last-child {
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
  }
  
  &:not(:first-child) {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  
  &:not(:last-child) {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
</style>
